import { gql } from '@apollo/client';
import vehiclePreviewFragment from '../../fragments/vehiclePreviewApollo';

const vehiclesKey = `vehiclesVehicles${process.env.GATSBY_STRAPI_VERSION === '5' ? '_connection' : ''}`;
const documentId = `${process.env.GATSBY_STRAPI_VERSION === '5' ? 'documentId' : ''}`;

export default gql`
  query GET_LIVE_VEHICLES($sort:[String] = [], $limit: Int = -1, $start: Int, $filters:VehiclesVehicleFiltersInput) {
    ${vehiclesKey}(sort:$sort, pagination:{ start:$start, limit:$limit }, filters:$filters) {
      ${process.env.GATSBY_STRAPI_VERSION !== '5' ? `
        meta {
          pagination {
            total
            page
            pageSize
            pageCount
          }
        }
      ` : `
        pageInfo {
          total
          page
          pageSize
          pageCount
        }
      `}
      data {
        id
        ${documentId}
        attributes {
          ...VehiclePreview
        }
      }
    }
  }

  ${vehiclePreviewFragment}
`;
